/**
 * Spectator API - Fetch live matches for spectating
 */

import { http } from './http';

export interface LiveMatch {
  matchId: string;
  roomId: string;
  players: Array<{ wallet: string; username: string }>;
  wagerAmount: number;
  currency: string;
  currentTurn: number;
  phase: string;
  startedAt: string;
}

interface LiveMatchesResponse {
  matches: LiveMatch[];
}

export const spectatorApi = {
  getLiveMatches: async (): Promise<LiveMatch[]> => {
    const response = await http.get<LiveMatchesResponse>('/matches/live');
    return response.matches;
  },
};
